import { Component, OnInit, Inject, NgModule, OnDestroy,ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { MatDialogRef } from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { appsettings } from '../app-settings';
import { AlertSharedService } from '../_services/index';
import { SharedFloorAlertData } from '../api';
import { RollbarService } from '../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck } from '../app-general';
import {Router} from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators'
import { ApiService } from '../api.service';
import { AppComponent } from '../app.component';
import {  StaffByIDparam } from '../landing/staff/staff';

@Component({
  selector: 'app-accesscode',
  templateUrl: './accesscode.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./accesscode.component.scss']
})
export class AccesscodeComponent implements OnInit,OnDestroy {
  SharedFloorAlertDetails: SharedFloorAlertData;
  S_AccessCodeType;
  S_CampusId;
  S_BuildingId;
  S_RoomId;
  S_FloorId;
  S_AlertId;
  txtaccessCodedisabled=false;
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router, private alertSharedService: AlertSharedService, mediaObserver: MediaObserver, 
    public thisDialogRef: MatDialogRef<AccesscodeComponent>,public apiService: ApiService,
     @Inject(RollbarService) private rollbar: Rollbar, @Inject(MAT_DIALOG_DATA) public data: any) {
    try {
      this.S_AccessCodeType = data.AccessCodeType;
      if (this.S_AccessCodeType == "SerachResident") {
        this.S_CampusId = data.CampusId;
        this.S_BuildingId = data.BuildingId;
        this.S_RoomId = data.RoomId;
        this.S_FloorId = data.FloorId;
        this.S_AlertId = data.AlertId;
      }
    }
    catch (err) {
      throw new Error('accesscode.component.ts' + ' - ngOnInit() - ' + err.message);
    }
  }
  SiteId = '1';
  password: string;
  counter = 0;
  lblattempt = ""
  lblaccessMsg ="";
  //lblaccessMsg = "Must enter access code before zooming in on individual's location."
  Max_pass_count = 3;
  Alert_Status = 2;
  ngOnInit() {
    this.alertSharedService.currentsharedFloorAlert().pipe(takeUntil(this._onDestroy)).subscribe((SharedFloorAlertDetails: SharedFloorAlertData) => { this.SharedFloorAlertDetails = SharedFloorAlertDetails });
  }

  // close alert Notification Dialog
  public onCloseAccesscode = () => {
    
    this.thisDialogRef.close('Cancel');
    if(!SessionCheck(this.router))
    {
        return;
    }
  }

  onKeyPress(): void {
    try {
      if (this.password == undefined || this.password == "") {
        let element3 = document.getElementById('btnaccessenter');
        element3.className = 'clsaccbutton_Enter mat-raised-button disable';
      }
      else {
        let element3 = document.getElementById('btnaccessenter');
        element3.className = 'clsaccbutton_Cancel mat-raised-button';
      }
    }
    catch (err) {
      throw new Error('accesscode.component.ts' + ' - onKeyPress() - ' + err.message);
    }
  }

  onEnterClicked(): void {
    try {
      if (!SessionCheck(this.router)) {
        this.thisDialogRef.close('Cancel');
        return;
      }
      this.lblattempt = "";

      var staffdata;
      
      var userid = localStorage.getItem("userid");
      let staffbyid: StaffByIDparam = {        
        authKey: localStorage.getItem("Authkey"),
        staffId : parseInt(userid)
      }
      
      this.apiService.getStaffDataById(staffbyid)
        .subscribe((staffinfo: any[]) => {
          this.alertSharedService.changesharedStaffData(staffinfo["apiReturn"]);
          if (AppComponent.SharedStaffDetails != undefined) {
            staffdata = AppComponent.SharedStaffDetails;

            if (this.password == staffdata[0]["Password"]) {
              // alert("AlertID:"+this.S_AlertId +" _"+ "RoomID:"+this.S_RoomId +" _"+ "FloorID:"+this.S_FloorId+" _"+ "BuildingId:"+this.S_BuildingId+" _"+ "CampusId:"+this.S_CampusId)
              if (this.S_AccessCodeType == "SerachResident") {
                var _SharedFloorAlertDetails = {
                  "SharedFloorCampusId": this.S_CampusId,
                  "SharedFloorBuildingId": this.S_BuildingId,
                  "SharedFloorFloorId": this.S_FloorId, //this is campus view so no floor info
                  "SharedFloorAlertId": this.S_AlertId,
                  "SharedFloorRoomId": this.S_RoomId,
                  "SharedFloorAlertStatus": this.Alert_Status
                };

                this.alertSharedService.changesharedFloorAlert(_SharedFloorAlertDetails);
              }
              this.thisDialogRef.close('Confirm');
            }
            else if (this.password == undefined || this.password == "") {
              let element3 = document.getElementById('btnaccessenter');
              element3.className = 'clsaccbutton_Enter mat-raised-button disable';
            }
            else {
              let element = document.getElementById('accessmsg');
              element.className = 'clswrongaccesscode';
              this.lblaccessMsg = "Invalid access code. Please enter the correct code.";
              this.counter = this.counter + 1;
              if (this.counter == this.Max_pass_count) {
                let element4 = document.getElementById('btnaccessenter');
                element4.className = 'btnaccessenter';
                let element1 = document.getElementById('accessmsgcnt');
                element1.className = 'clsattemptfailed';
                let element2 = document.getElementById('actionDiv');
                element2.className = 'disable';
                this.txtaccessCodedisabled = true;
                let element3 = document.getElementById('btnaccessenter');
                element3.className = 'clsaccbutton_Enter mat-raised-button disable';

                this.lblattempt = "Incorrect Access Code ";
              }
              else if (this.counter < this.Max_pass_count) {
                this.lblattempt = "You have " + (this.Max_pass_count - this.counter) + " attempts left";
              }
              else {
                this.lblattempt = "Incorrect Access Code ";
              }
            }
          }
        });

    }
    catch (err) {
      throw new Error('accesscode.component.ts' + ' - onEnterClicked() - ' + err.message);
    }
  }
  
    ngOnDestroy() {
      this._onDestroy.next();
      this._onDestroy.complete();
    }
}
